import { FrameworksBoard } from "../../../../shared/dashboard/FrameworksBoard"
import type { DashboardWidgetProps } from "../customerWidgetRegistry"

// Mirrors the supplier dashboard's FrameworksWidget via the shared
// FrameworksBoard: product-level coverage bars, one per regulation in the
// org's set.
export function FrameworksWidget({ stats, loadFailed }: DashboardWidgetProps) {
  return (
    <FrameworksBoard
      frameworks={stats.frameworks}
      loadFailed={loadFailed}
      popLabelKey="MC_CSD_POP_PRODUCTS"
      coveredHintKey="MC_DASH_CUSTOMER_COVERED_HINT"
      showTotalInAbs
    />
  )
}
